export { DetailsAdvice } from './DetailsAdvice';
